import EmployeeNavigationContainer from './components/EmployeeNavigationContainer';

export default EmployeeNavigationContainer;
